import { FormattedDollars } from "./formatted-currency";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function TransactionSummary({ amount }) {
  return (
    <div className="batch-c-1-1 batch-c-md-1-3 batch-c-order-md-2">
      <h2 className="margin-top--is-5">
        Transaction Summary
      </h2>

      <div className="summary">
        <dl className="summary_row summary_row--total">
          <dt>
            Total Deposit:
          </dt>

          <dd>
            <FormattedDollars showCents value={amount || 0} />
          </dd>
        </dl>
      </div>
    </div>
  );
});
